module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin11-2f89a78acf388786ecc8aa3d770935f3.jpg";